module.exports = __webpack_public_path__ + "static/img/10.b6c8110.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/zh/10.png
// module id = u88g
// module chunks = 0